import React from 'react';

export const getContent = (n) => {
  switch (n.type) {
    case 'web-comment':
    case 'false-comment': // Rarely caused due to false type checking.
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          {n.length > 1 ? (
            <span>{` left ${n.length} comments on page `}</span>
          ) : (
            <span> commented on page </span>
          )}
          {n.context.pageTitle && (
            <span className="bold">
              {`${n.context.pageTitle.substring(0, 15)}${
                n.context.pageTitle.length > 15 ? '...' : ''
              }`}
            </span>
          )}
        </>
      );
    case 'web-comment-mention':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> mentioned you in a comment on page </span>
          {n.context.pageTitle && (
            <span className="bold">
              {`${n.context.pageTitle.substring(0, 15)}${
                n.context.pageTitle.length > 15 ? '...' : ''
              }`}
            </span>
          )}
        </>
      );
    case 'web-comment-reply':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> replied to your comment on page </span>
          {n.context.pageTitle && (
            <span className="bold">
              {`${n.context.pageTitle.substring(0, 15)}${
                n.context.pageTitle.length > 15 ? '...' : ''
              }`}
            </span>
          )}
        </>
      );
    case 'web-comment-reply-mention':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> replied to a comment you were mentioned on page </span>
          {n.context.pageTitle && (
            <span className="bold">
              {`${n.context.pageTitle.substring(0, 15)}${
                n.context.pageTitle.length > 15 ? '...' : ''
              }`}
            </span>
          )}
        </>
      );
    case 'illustration-comment':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> commented on an illustration</span>
        </>
      );
    case 'illustration-comment-mention':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> mentioned you in a comment on an illustration</span>
        </>
      );
    case 'illustration-comment-reply':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> replied to your comment on an illustration</span>
        </>
      );
    case 'illustration-comment-reply-mention':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span>{` replied to a comment you were mentioned on an illustration`}</span>
        </>
      );
    case 'web-inspect': {
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span>
            {` suggested ${
              n.context.editsCount === 1
                ? '1 edit'
                : `${n.context.editsCount} edits`
            } on page `}
          </span>
          {n.context.pageTitle && (
            <span className="bold">
              {`${n.context.pageTitle.substring(0, 15)}${
                n.context.pageTitle.length > 15 ? '...' : ''
              }`}
            </span>
          )}
        </>
      );
    }
    case 'project-share':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> invited you to a project</span>
        </>
      );
    case 'web-page-add':
      return (
        <>
          <span className="bold">
            {n.context.userName || n.context.displayName}
          </span>
          <span> added a page </span>
          {n.context.pageTitle && (
            <span className="bold">
              {`${n.context.pageTitle.substring(0, 15)}${
                n.context.pageTitle.length > 15 ? '...' : ''
              }`}
            </span>
          )}
        </>
      );

    case 'team-member-add':
      return (
        <>
          <span className="bold">{n.context.displayName}</span>
          <span> invited you to team </span>
          <span className="bold">{n.context.teamName}</span>
        </>
      );

    case 'team-member-access':
      return (
        <>
          <span>You are now </span>
          <span className="bold" style={{ textTransform: 'capitalize' }}>
            {n.context.access}
          </span>
          <span> in </span>
          <span className="bold">{n.context.teamName}</span>
        </>
      );

    case 'team-member-left':
      return (
        <>
          <span className="bold" style={{ textTransform: 'capitalize' }}>
            {n.context.displayName}
          </span>
          <span> left your team </span>
          <span className="bold">{n.context.teamName}</span>
        </>
      );

    case 'make-approver':
      return (
        <>
          You are now an <span className="bold">approver</span> on project{' '}
          <span className="bold">{n.context.projectName}</span>
        </>
      );

    case 'page-approved':
      return (
        <>
          <span className="bold">{n.context.displayName}</span> has marked page{' '}
          <span className="bold">{n.context.page}</span> as{' '}
          <span className="bold">Approved</span>
        </>
      );

    case 'page-unapproved':
      return (
        <>
          <span className="bold">{n.context.displayName}</span> has marked page{' '}
          <span className="bold">{n.context.page}</span> as{' '}
          <span className="bold">Unapproved</span>
        </>
      );

    default:
      return '';
  }
};

export const getLink = (n) => {
  switch (n.type) {
    case 'web-comment':
    case 'false-comment': // Rarely caused due to false type checking.
    case 'web-comment-mention':
    case 'web-comment-reply':
    case 'web-comment-reply-mention':
      return `/project/${n.context.projectID}/${n.context.pageID}/${n.context.versionID}/comment?id=${n.context.commentID}`;
    case 'illustration-comment':
    case 'illustration-comment-mention':
    case 'illustration-comment-reply':
    case 'illustration-comment-reply-mention':
      return `/project/${n.context.projectID}/?id=${n.context.commentID}`;
    case 'web-inspect':
      return `/project/${n.context.projectID}/${n.context.pageID}/${n.context.versionID}/inspect?activity=true`;
    case 'project-share':
    case 'make-approver':
      return `/project/${n.context.projectID}`;
    case 'web-page-add':
    case 'page-approved':
    case 'page-unapproved':
      return `/project/${n.context.projectID}/${n.context.pageID}/${n.context.versionID}/preview`;
    case 'team-member-add':
    case 'team-member-access':
    case 'team-member-left':
      return `/team/${n.context.teamID}`;
    default:
      return '';
  }
};
